import schools from "json/schools"

export default schools
